import {publish} from "messaging/queue.js";
import {doc} from './documentation.js';
import {lazy, filter} from './lang.js';

doc(
    "triggerAttack",
    {
        "trackNumber": "",
        "transpose": "",
        "velocity": "",
    },
    "Triggers an attack (note on) for a given tracks instrument"
);
export const triggerAttack = (trackNumber, transpose, velocity=1) => {
    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        let subName = effect.track.subSequence.name.toLowerCase();
        let _trackNumber = lazy(trackNumber, ...args);
        let _velocity = lazy(velocity, ...args);
        let type = _trackNumber + subName + ".triggerAttack";
        if (stepData) {
            let _transpose = undefined;
            if (transpose === undefined) {
                _transpose = stepData.transpose;
            } else {
                _transpose = lazy(transpose, ... args);
            }
            publish(type, {trackNumber, time, transpose: _transpose, velocity: _velocity});
        }
        return filter(true);
    };
};

doc(
    "triggerRelease",
    {
        "trackNumber": "",
        "transpose": "",
    },
    "Triggers a release (note off) for a given tracks instrument"
);
export const triggerRelease = (trackNumber, transpose) => {
    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        let subName = effect.track.subSequence.name.toLowerCase();
        let type = trackNumber + subName + ".triggerRelease";
        if (stepData) {
            let _transpose = 0;
            if (transpose === undefined) {
                _transpose = stepData.transpose;
            }
            publish(type, {trackNumber, time, transpose: _transpose});
        }
        return filter(true);
    };
};
